import { combineReducers } from 'redux'
import loginInfo from './loginInfo'

const loginLogoutActions = [
	'Logout/REQUEST',
	'Login/SUCCESS'
]

const LOGININFONAME = 'loginInfo'

const reducer = (reducers, reducerName) => (state = reducers[reducerName].initValue, action) => {
	// 登入/登出时所有redux模块（loginInfo除外）恢复初始值
	const actionType = (reducerName !== LOGININFONAME && loginLogoutActions.includes(action.type) && 'initValue') || action.type
	if (Object.keys(reducers[reducerName]).includes(actionType)) {
		const fun = reducers[reducerName][actionType]
		if (typeof fun === 'function') return fun(state, action)
		return fun
	}
	return state
}

const getReduces = reducers => {
	const ret = Object.entries(reducers).reduce((before, [key, value]) => ({
		...before,
		[key]: (typeof value === 'function' && value) || reducer(reducers, key)
	}), {})

	return ret
}

export default combineReducers(getReduces({
	loginInfo,
}))
